/**
 * Document Type Constants
 * 1 = Manufacturing Process Instruction
 * 2 = Process Drawing
 * 3 = Quality Instruction
 * 4 = Process Flow
 * 5 = Control Plan
 * 6 = Parameter
 */

export const DOC_TYPE_IDS = {
    MANUFACTURING: 1,
    PROCESS_DRAWING: 2,
    QUALITY_INSTRUCTION: 3,
    PROCESS_FLOW: 4,
    CONTROL_PLAN: 5,
    PARAMETER: 6
};

export const DOC_TYPE_LABELS = {
    [DOC_TYPE_IDS.MANUFACTURING]: "Manufacturing Process Instruction",
    [DOC_TYPE_IDS.PROCESS_DRAWING]: "Process Drawing",
    [DOC_TYPE_IDS.QUALITY_INSTRUCTION]: "Quality Instruction",
    [DOC_TYPE_IDS.PROCESS_FLOW]: "Process Flow",
    [DOC_TYPE_IDS.CONTROL_PLAN]: "Control Plan",
    [DOC_TYPE_IDS.PARAMETER]: "Parameter"
};

/**
 * Get display label from type ID
 * @param {number} typeId 
 * @returns {string}
 */
export const getDocTypeLabel = (typeId) => {
    return DOC_TYPE_LABELS[typeId] || 'Unknown Type';
};